import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const packagingCertificationImporterSelectors = importerSelectors(
  'packagingCertification.importer',
);

export default packagingCertificationImporterSelectors;
